import { useTranslation } from "react-i18next";
import { cn } from "../../lib/utils.js";
import { CollapsibleChipList } from "./CollapsibleChipList.js";
import { contactGroupChipClassName } from "./contact-group-color.js";

export function ContactGroupPreview({
  groups,
  empty,
  testId,
  collapsible = false,
  className,
}: {
  groups: ReadonlyArray<{ id: number; name: string }>;
  empty?: React.ReactNode;
  testId?: string;
  collapsible?: boolean;
  className?: string;
}): React.JSX.Element {
  const { t } = useTranslation();

  if (groups.length === 0) {
    return <>{empty ?? null}</>;
  }

  return (
    <CollapsibleChipList
      items={groups}
      getKey={(group) => group.id}
      className={className}
      testId={testId}
      moreLabel={(count) => t("contacts.groups.more", { count })}
      showLessLabel={collapsible ? t("contacts.groups.showLess") : undefined}
      renderChip={(group) => (
        <span className={cn(contactGroupChipClassName(group.id), "min-w-0")} title={group.name}>
          <span className="min-w-0 truncate">{group.name}</span>
        </span>
      )}
    />
  );
}
